import Image from "next/image";
import PropTypes from "prop-types";
import { getIconUrl } from "../../../utils/common";

/**
 * Represents a Brick component.
 * @param {Object} props - The props object.
 * @param {string} props.id - The unique identifier for the Brick.
 * @param {string} props.content - The content to be displayed in the Brick.
 * @param {string} props.icon - The URL of the icon to be displayed alongside the content.
 * @param {string} props.contentClass - Additional CSS classes for the content span.
 * @param {string} props.bgColor - Background color of the Brick.
 * @param {string} props.alignment - Alignment of the content within the Brick.
 * @param {function} props.onClick - Function to be called when the Brick is clicked.
 * @returns {JSX.Element} - The Brick component.
 */
const Brick = ({
  id = "brick-component",
  content,
  icon,
  contentClass = "",
  bgColor,
  alignment = "start",
  onClick,
  customStyle = {},
  imageWidth = 14,
  imageHeight = 14,
}) => {
  const defaultClass = `flex justify-${alignment} items-center ${bgColor}`;

  return (
    <div id={id} style={customStyle} className={defaultClass} onClick={onClick}>
      {icon && (
        <Image
          src={getIconUrl(icon)}
          alt={`${content}_start_icon`}
          className="p-1"
          width={imageWidth}
          height={imageHeight}
        />
      )}
      <span className={`font-inter font-medium leading-16 ${contentClass}`}>{content}</span>
    </div>
  );
};

Brick.propTypes = {
  content: PropTypes.string.isRequired,
  icon: PropTypes.string,
  id: PropTypes.string,
  contentClass: PropTypes.string,
  bgColor: PropTypes.string.isRequired,
  alignment: PropTypes.oneOf(["start", "center", "end"]),
  onClick: PropTypes.func,
  customStyle: PropTypes.object,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number,
};

export default Brick;
